module.exports = "<div class=\"popup info-factory-popup\">\n  <h1 class=\"popup-subtitle\" data-localize=\"info.factory.title\"></h1>\n  <div class=\"feedback-mode popup-message\" data-localize=\"info.factory.microchip.feedback\"></div>\n  <div class=\"feedback-mode popup-resource-result\">\n    <div class=\"resource-cost\"></div>\n    <div><i class=\"fa fa-angle-right\"></i></div>\n    <div class=\"resource-produce\"></div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/popup/info-factory.html
// module id = 815
// module chunks = 2